import React from "react";

const MODULES = [
  "Agenda Inteligente",
  "Prontuário Digital",
  "Banho & Tosa",
  "Taxi-Dog",
  "Fluxo de Caixa",
  "Controle de Estoque",
  "Portal do Tutor",
  "Relatórios em PDF",
  "Gestão de Equipe",
  "Pacotes de Serviços",
  "Alertas de Vacina",
  "WhatsApp Integrado",
];

const Dot = () => (
  <svg className="h-2 w-2 shrink-0 text-pawOrange" viewBox="0 0 8 8" fill="currentColor">
    <circle cx="4" cy="4" r="4" />
  </svg>
);

/** Faixa infinita com os módulos da plataforma. Pausa no hover. */
const Marquee = () => {
  const items = [...MODULES, ...MODULES];

  return (
    <section
      aria-label="Módulos da plataforma"
      className="relative border-y border-midnight/[.07] bg-white/60 py-6 backdrop-blur-sm"
    >
      <div className="marquee-mask overflow-hidden">
        <div className="marquee-track flex w-max animate-marquee items-center gap-8">
          {items.map((item, i) => (
            <React.Fragment key={`${item}-${i}`}>
              <span className="whitespace-nowrap font-display text-lg font-bold tracking-tight text-midnight/35 transition-colors duration-300 hover:text-midnight">
                {item}
              </span>
              <Dot />
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marquee;
